import config from 'config';
import {
  MF_SELF_SERVICE_ROUTES,
  salesManagementRoutes,
  STARGATE_ROUTES,
} from 'config/application-routes';
import type { Settings } from 'core/domains';

const routeErrorBase = {
  component: 'Error',
  documentType: '',
  isPrivate: false,
};

const routePageBuilder = {
  component: 'PageBuilder',
  isHomepage: false,
  isPrivate: true,
  isMainHeader: true,
  isSearchPage: false,
};

const StargateStaticRoutes = [
  {
    component: 'LoadingPage',
    documentType: '',
    isPrivate: true,
    path: STARGATE_ROUTES.INDEX,
    isMainHeader: true,
  },
  {
    component: 'ResaleIntentionPage',
    documentType: '',
    isPrivate: true,
    path: STARGATE_ROUTES.RESALE_INTENTION,
    isMainHeader: true,
  },
  {
    component: 'ExtendedCaptationPage',
    documentType: '',
    isPrivate: true,
    path: STARGATE_ROUTES.EXTENDED_CAPTATION,
    isMainHeader: true,
  },
  {
    component: 'ContentAPI',
    documentType: '',
    isPrivate: false,
    path: STARGATE_ROUTES.CONTENT_API,
  },
  {
    ...routeErrorBase,
    path: STARGATE_ROUTES.ERROR_500,
    canBlockedResellerAccess: true,
  },
  {
    ...routeErrorBase,
    path: STARGATE_ROUTES.ERROR_GENERIC,
    canBlockedResellerAccess: true,
  },
  {
    ...routeErrorBase,
    path: STARGATE_ROUTES.ERROR_401,
    canBlockedResellerAccess: true,
  },
  {
    ...routeErrorBase,
    path: STARGATE_ROUTES.ERROR_403,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'ErrorVDF',
    documentType: '',
    isPrivate: false,
    path: STARGATE_ROUTES.ERROR_VDF,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    ...routeErrorBase,
    path: STARGATE_ROUTES.ERROR_PROCESS,
  },
  {
    component: 'Login',
    documentType: '',
    isPublic: true,
    isPrivate: false,
    path: STARGATE_ROUTES.LOGIN || '/login/',
    isMainHeader: false,
  },
  {
    component: 'Faq',
    documentType: '',
    isPublic: true,
    isPrivate: false,
    path: STARGATE_ROUTES.FAQ,
    isMainHeader: false,
  },
  {
    component: 'Logout',
    documentType: '',
    isPublic: true,
    path: STARGATE_ROUTES.LOGOUT,
    isMainHeader: false,
  },
  {
    component: 'PageGifts',
    documentType: '',
    isHomepage: false,
    isPrivate: true,
    isMainHeader: false,
    isSearchPage: false,
    name: 'Gifts',
    path: STARGATE_ROUTES.GIFTS,
  },
  {
    component: 'PageProductsByTag',
    documentType: '',
    isHomepage: false,
    isPrivate: true,
    isMainHeader: true,
    isSearchPage: false,
    name: 'ProductsByTag',
    path: STARGATE_ROUTES.PRODUCTS_BY_TAG,
  },
  {
    component: 'PageEmptyRecommendation',
    documentType: '',
    isHomepage: false,
    isPrivate: true,
    isMainHeader: true,
    isSearchPage: false,
    name: 'PageEmptyRecommendation',
    path: STARGATE_ROUTES.EMPTY_RECOMMENDATION,
  },
  {
    component: 'PageTapume',
    documentType: '',
    isPrivate: false,
    path: STARGATE_ROUTES.TAPUME,
    isMainHeader: false,
  },
  {
    isMainHeader: true,
    isPrivate: true,
    documentType: 'page-departments',
    isHomepage: true,
    name: 'Departamentos',
    path: config.app.homepage,
    component: 'PageDepartments',
  },
  {
    component: 'PageCategory',
    documentType: '',
    isHomepage: false,
    isPrivate: true,
    isMainHeader: true,
    isSearchPage: false,
    name: 'PageCategory',
    path: STARGATE_ROUTES.CATEGORIES,
  },
  {
    ...routePageBuilder,
    documentType: 'broken_type',
    isMainHeader: false,
    name: 'Erro ao processar descontos',
    path: STARGATE_ROUTES.ERROR_PROCESS,
  },
  {
    ...routePageBuilder,
    documentType: 'page-combo',
    name: 'Combo personalizado',
    path: STARGATE_ROUTES.COMBO,
  },
  {
    ...routePageBuilder,
    documentType: 'page-combo-error',
    isMainHeader: false,
    name: 'Combo sem estoque',
    path: STARGATE_ROUTES.ERROR_COMBO,
  },
  {
    component: 'PageCheckout',
    isHomepage: false,
    isPrivate: true,
    isMainHeader: false,
    isSearchPage: false,
    name: 'Checkout',
    path: STARGATE_ROUTES.CHECKOUT,
  },
  {
    component: 'PageOrderSuccess',
    documentType: 'page-confirmation',
    isHomepage: false,
    isPrivate: true,
    isMainHeader: false,
    isSearchPage: false,
    name: 'Confirmação de compra',
    path: STARGATE_ROUTES.CHECKOUT_CONFIRMATION,
  },
  {
    ...routePageBuilder,
    documentType: 'page-categories',
    name: 'Departamento',
    path: STARGATE_ROUTES.DEPARTMENT,
  },
  {
    component: 'PageSearch',
    documentType: '',
    isHomepage: false,
    isPrivate: true,
    isMainHeader: true,
    isSearchPage: true,
    name: 'Resultado da Busca',
    path: STARGATE_ROUTES.SEARCH,
  },
  {
    component: 'PageProductDetail',
    isHomepage: false,
    isPrivate: true,
    isMainHeader: true,
    isSearchPage: false,
    name: 'Página de detalhe do produto',
    path: STARGATE_ROUTES.PRODUCT_DETAIL,
  },
  {
    component: 'RecoverPassword',
    documentType: '',
    isPublic: true,
    isPrivate: false,
    path: STARGATE_ROUTES.RECOVER_PASSWORD,
    isMainHeader: false,
  },
  {
    component: 'RecoverPasswordEmail',
    documentType: '',
    isPublic: true,
    isPrivate: false,
    path: STARGATE_ROUTES.RECOVER_PASSWORD_EMAIL,
    isMainHeader: false,
  },
  {
    component: 'RecoverPasswordEmailSuccess',
    documentType: '',
    isPublic: true,
    isPrivate: false,
    path: STARGATE_ROUTES.RECOVER_PASSWORD_EMAIL_SUCCESS,
    isMainHeader: false,
  },
  {
    component: 'CartPage',
    isHomepage: false,
    isPrivate: true,
    isMainHeader: false,
    isSearchPage: false,
    name: 'Carrinho',
    path: STARGATE_ROUTES.CART,
  },
] as Settings['data']['routes'];

const MfResellerManagement = [
  {
    canBlockedResellerAccess: false,
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.RESELLER_SPACE,
    isMainHeader: true,
  },
  {
    canBlockedResellerAccess: false,
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.REPRESENTANT_SPACE,
    isMainHeader: true,
  },
  {
    canBlockedResellerAccess: true,
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.CYCLES_CATALOG,
    isMainHeader: true,
  },
  {
    canBlockedResellerAccess: true,
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.CYCLES_CATALOG_ACTUAL,
    isMainHeader: true,
  },
  {
    canBlockedResellerAccess: true,
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.CYCLES_CATALOG_NEXT,
    isMainHeader: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.DIGITAL_GUIDE,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },

  {
    canBlockedResellerAccess: true,
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.DIVULGATION_IMAGES,
    isMainHeader: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.DIVULGATION_IMAGES_CONTENT,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.IMPORTANT_WARNINGS,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.IMPORTANT_WARNINGS_CONTENT,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.CYCLE_HIGHLIGHTS,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.CYCLE_HIGHLIGHTS_CONTENT,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.TIPS_AND_TRAINING,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.TIPS_AND_TRAINING_CONTENT,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.RESELLER_MAGAZINE,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.RESELLER_MAGAZINE_CONTENT,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.PLUS_GUIDE,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.PLUS_GUIDE_CONTENT,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    canBlockedResellerAccess: true,
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.ORDERS,
    isMainHeader: true,
  },
  {
    canBlockedResellerAccess: true,
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.ORDER,
    isMainHeader: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.CATALOG_CONFIG,
    isMainHeader: true,
    canBlockedResellerAccess: false,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.PROFILE,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.PROFILE_EDIT_CELLPHONE_PASSWORD,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.PROFILE_EDIT_CELLPHONE_CONFIRMATION,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.PROFILE_EDIT_CELLPHONE_SUCCESS,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.PROFILE_EDIT_CELLPHONE_ERROR,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.PROFILE_EDIT_ADDRESS_PASSWORD,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.PROFILE_EDIT_ADDRESS_IMPORTANT_INFORMATION,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.PROFILE_EDIT_ADDRESS_CONFIRMATION,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.PROFILE_EDIT_ADDRESS_MODAL_CONFIRMATION,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.PROFILE_EDIT_ADDRESS_SUCCESS,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.PROFILE_EDIT_ADDRESS_ERROR,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.INCENTIVES_CAMPAIGN,
    isMainHeader: true,
    canBlockedResellerAccess: false,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.INCENTIVES_CAMPAIGN_RESULT,
    isMainHeader: true,
    canBlockedResellerAccess: false,
  },
  {
    component: 'MfSelfService',
    documentType: '',
    isPrivate: true,
    path: MF_SELF_SERVICE_ROUTES.MATERIALS,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  },
] as Settings['data']['routes'];

export const staticRoutes = [
  ...StargateStaticRoutes,
  ...MfResellerManagement,
  ...salesManagementRoutes.map((route) => ({
    component: 'MfResellerManagement',
    documentType: '',
    isPrivate: true,
    path: `/gestao-de-vendas/${route}`,
    isMainHeader: true,
    canBlockedResellerAccess: true,
  })),
] as Settings['data']['routes'];
